export default "__VITE_ASSET__CNAP4EzL__"